import styled from "styled-components";

export const ImageWithTextContainer = styled.section`
  
    
  .mygrid-row {
    flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
    align-items: center;
    border-bottom: 1px solid #A1A0A0;
    padding: 100px 0;
    &.reverse {
      flex-direction: row-reverse;
    }
  }

.mygrid-row.reverse-row {
    flex-direction: row-reverse;
}
  .img_text_image {
    img {
      width: 100%;
      max-width:625px;
    }
  }

  .imgtext_content {
    max-width: 600px;

    h5.subheading {
      color: #197f9f;
      font-weight: 600;
      margin-bottom: 10px;
    }

    p {
      margin: 20px 0;
      line-height: 1.6;
      color: #333;
    }

    .intro_learnmore {
      margin-top: 20px;
    }
  }

  @media (max-width: 991px) {
    .mygrid-row {
      flex-direction: column;
    }
    .imgtext_content {
      margin-top: 30px;
      max-width: 880px;
    }
    .img_text_image {
        text-align: center;
    }
    .imgwithtext-wrapper .mygrid-row {
        padding: 50px 0;
        justify-content: center;
    }
  }
`;
